module.exports = __webpack_public_path__ + "static/media/message2.47b21083.png";